export const tr = {
    copied: 'Kopyalandı',
    'copy-error': 'Kopyalama hatası',
    'copy-link': 'Koşulları panoya kopyala',
    metrikaAudience: 'Yandex.Audience ve Yandex.Metrica',
    'open-popup-text': 'Gösterim koşullarını göster',
    'popup-title': 'Gösterim koşulları',
    'users-profiles': 'Kullanıcı profili'
};
